/** Liste masquée effective : défauts tant que la vue n’a jamais été persistée. */
export function resolveHidden(
  stored: string[] | undefined,
  defaultHidden: string[] = [],
): string[] {
  return stored ?? defaultHidden;
}

/** Premier toggle d’une vue part des défauts, pas d’une liste vide. */
export function toggleHiddenKey(
  stored: string[] | undefined,
  key: string,
  defaultHidden: string[] = [],
): string[] {
  const current = resolveHidden(stored, defaultHidden);
  return current.includes(key)
    ? current.filter((k) => k !== key)
    : [...current, key];
}
